import React, { useState, useContext, useEffect } from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import CircularProgress from '@mui/material/CircularProgress'
import debounce from 'lodash.debounce'

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay)
    })
}

const SearchSelectComponent = (props) => {
    const [selectedOption, setSelectedOption] = useState([])
    const [singleOption, setSingleOption] = useState({ show: '', value: '' })
    const [optionData, setOptionData] = useState([])
    const [edit, setEdit] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [options, setOptions] = useState([])
    const [showDropdown, setShowDropdown] = useState(false)

    const [open, setOpen] = useState(false)

    const [loading, setLoading] = useState(false)

    // useEffect(() => {
    //     let active = true

    //     if (!loading) {
    //         return undefined
    //     }

    //     return () => {
    //         active = false
    //     }
    // }, [loading])

    // useEffect(() => {
    //     if (!open) {
    //         setOptions([])
    //     }
    // }, [open])
    function trimVal(data) {
        let value = data
        let arr = value?.split('    ')
        if (arr?.length > 1) {
            value = arr[0].trim() + ' ' + arr[arr.length - 1].trim()
        }
        return value
    }

    useEffect(() => {
        if (props.options) {
            setOpen(false)
            if (props.options.length) {
                let allData = props.options
                if (props.value && edit) {
                    let singleData = allData.filter(
                        (item) => item?.value == props?.value
                    )

                    if (props.multiple) {
                        if (props.value.length) {
                            singleData = props.options.filter((item) =>
                                props.value.includes(item.value)
                            )
                            let allValues = selectedOption.concat(singleData)
                            setSelectedOption(allValues)
                        } else {
                            setSelectedOption([])
                        }
                    } else {
                        setSingleOption({
                            show: trimVal(singleData[0]?.show),
                            value: props.value,
                        })
                        setSelectedOption([])
                    }
                    // setSingleOption({
                    //     show: allData[0].show,
                    //     value: props.value,
                    // })
                    setEdit(false)
                    setLoading(false)
                    setOpen(false)
                } else {
                    setOptionData(allData)
                    setLoading(false)
                    setOpen(true)
                    setShowDropdown(true)
                }
            } else {
                setOptionData([])
                setLoading(false)
                setOpen(false)
                setShowDropdown(false)
            }
        }
    }, [props.options, edit])

    const debounceFunc = debounce((value) => {
        props.getAllOptions(value)
    }, 1500)

    const getReturnMultipleValues = (value) => {
        let returnValue = props.options.filter(
            (item) => item.value === parseInt(value)
        )

        if (returnValue.length) {
            let allValues = selectedOption.concat(returnValue)
            setSelectedOption(allValues)
            props.onChange(getMultipleValues(allValues))
        }
    }

    const handleSearchChange = (value) => {
        setLoading(true)
        setSearchValue(value)
        if (props.multiple) {
            getReturnMultipleValues(value)
        } else {
            setSingleOption({ show: value, value: value })
        }
        debounceFunc(value)
    }

    useEffect(() => {
        if (
            props.value &&
            props.value !== '' &&
            props.options &&
            props.options.length == 0
        ) {
            props.getAllOptions(props.value)
            setEdit(true)
        }
    }, [props.value])

    const getMultipleValues = (values) => {
        setSelectedOption(values)
        return values.map((item) => item.value)
    }

    const getSingleValue = (selectedOption) => {
        setSingleOption(selectedOption)
        props.onChange(selectedOption.value)
    }

    useEffect(() => {
        if (props.value == '' && props?.onClearDefault) {
            setSingleOption({ show: '', value: '' })
            setOptionData([])
        }
    }, [props.value])
    const normalize = (str) => str?.replace(/\D/g, '')

    return props.multiple ? (
        <Autocomplete
            id={props.id}
            multiple={props.multiple}
            value={selectedOption}
            disabled={props.disabled}
            onChange={(event, value) => {
                if (value) {
                    props.onChange(getMultipleValues(value))
                } else {
                    setSingleOption([])
                    setOptionData([])
                }
            }}
            onInputChange={(event, newInputValue) => {
                // Detect clearing of input
                if (newInputValue === '') {
                    if (props?.onClear) {
                        props.onClear() // Your custom clear function
                    } else {
                        setSelectedOption([])
                        setOptionData([]) // Clear the options
                        setSearchValue('') // Clear the search value
                    }
                }
            }}
            getOptionLabel={(option) => option.show}
            renderOption={(props, option) => (
                <li {...props} key={option.value}>
                    {' '}
                    {option.show}{' '}
                </li>
            )}
            options={optionData}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={props.label}
                    variant={props.variant ? props.variant : 'outlined'}
                    error={props.error}
                    value={props.value}
                    size={props.size}
                    disabled={props.disabled}
                    name={props.name}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? (
                                    <CircularProgress
                                        color="inherit"
                                        size={20}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && e.target.value) {
                            handleSearchChange(e.target.value)
                        } else {
                            // setOptionData([])
                            // setSingleOption({ show: '', value: '' })
                        }
                    }}
                    onChange={(e) => {
                        if (e.target.value) {
                            handleSearchChange(e.target.value)
                        } else {
                            setOptionData([])
                            setSelectedOption([])
                        }
                    }}
                    helperText={props.helperText}
                    autoFocus={props.autoFocus}
                />
            )}
            autoFocus={props.autoFocus}
        />
    ) : props?.phoneSearch ? (
        <Autocomplete
            id="asynchronous-demo"
            style={props.style ? props.style : { width: 300 }}
            forcePopupIcon={props.forcePopupIcon}
            disabled={props.disabled}
            // open={open}
            // onOpen={() => {
            //     setOpen(true)
            // }}
            // onClose={() => {
            //     setOpen(false)
            // }}
            onInputChange={(event, newInputValue) => {
                // Detect clearing of input
                if (newInputValue === '') {
                    if (props?.onClear) {
                        props.onClear() // Your custom clear function
                    } else {
                        setSingleOption({ show: '', value: '' }) // Reset selected option
                        setOptionData([]) // Clear the options
                        setSearchValue('') // Clear the search value
                    }
                }
            }}
            value={singleOption}
            onChange={(event, value) => {
                if (value) {
                    getSingleValue(value)
                } else {
                    setSingleOption({ show: '', value: '' })
                    setOptionData([])
                }
            }}
            filterOptions={(options, { inputValue }) =>
                options?.filter((option) =>
                    normalize(option.show).includes(normalize(inputValue))
                )
            }
            renderOption={(props, option) => (
                <li {...props} key={option.value}>
                    {' '}
                    {option.show}{' '}
                </li>
            )}
            getOptionLabel={(option) => option.show}
            options={optionData}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={props.label}
                    variant={props.variant ? props.variant : 'outlined'}
                    error={props.error}
                    value={props.value}
                    size={props.size}
                    name={props.name}
                    placeholder={props.placeholder}
                    focused={props.focused ? props.focused : false}
                    disabled={props.disabled}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? (
                                    <CircularProgress
                                        color="inherit"
                                        size={20}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && e.target.value) {
                            handleSearchChange(e.target.value)
                        } else {
                            // setOptionData([])
                            // setSingleOption({ show: '', value: '' })
                        }
                    }}
                    onChange={(e) => {
                        if (e.target.value) {
                            handleSearchChange(e.target.value)
                        } else {
                            setOptionData([])
                            setSingleOption({ show: '', value: '' })
                        }
                    }}
                    helperText={props.helperText}
                    autoFocus={props.autoFocus}
                />
            )}
        />
    ) : (
        <Autocomplete
            id="asynchronous-demo"
            style={props.style ? props.style : { width: 300 }}
            forcePopupIcon={props.forcePopupIcon}
            disabled={props.disabled}
            // open={open}
            // onOpen={() => {
            //     setOpen(true)
            // }}
            // onClose={() => {
            //     setOpen(false)
            // }}
            onInputChange={(event, newInputValue) => {
                // Detect clearing of input
                if (newInputValue === '') {
                    if (props?.onClear) {
                        props.onClear() // Your custom clear function
                    } else {
                        setSingleOption({ show: '', value: '' }) // Reset selected option
                        setOptionData([]) // Clear the options
                        setSearchValue('') // Clear the search value
                    }
                }
            }}
            value={singleOption}
            onChange={(event, value) => {
                if (value) {
                    getSingleValue(value)
                } else {
                    setSingleOption({ show: '', value: '' })
                    setOptionData([])
                }
            }}
            renderOption={(props, option) => (
                <li {...props} key={option.value}>
                    {' '}
                    {option.show}{' '}
                </li>
            )}
            getOptionLabel={(option) => option.show}
            options={optionData}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={props.label}
                    variant={props.variant ? props.variant : 'outlined'}
                    error={props.error}
                    value={props.value}
                    size={props.size}
                    name={props.name}
                    placeholder={props.placeholder}
                    focused={props.focused ? props.focused : false}
                    disabled={props.disabled}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? (
                                    <CircularProgress
                                        color="inherit"
                                        size={20}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && e.target.value) {
                            handleSearchChange(e.target.value)
                        } else {
                            // setOptionData([])
                            // setSingleOption({ show: '', value: '' })
                        }
                    }}
                    onChange={(e) => {
                        if (e.target.value) {
                            handleSearchChange(e.target.value)
                        } else {
                            setOptionData([])
                            setSingleOption({ show: '', value: '' })
                        }
                    }}
                    helperText={props.helperText}
                    autoFocus={props.autoFocus}
                />
            )}
        />
    )
}

export default SearchSelectComponent
